import React from "react";

type Tab = {
    label: string;
    key: string;
};

type TabsProps = {
    tabs: Tab[];
    activeKey: string;
    onChange: (key: string) => void;
};

const Tabs: React.FC<TabsProps> = ({ tabs, activeKey, onChange }) => {
    return (
        <div style={{ borderBottom: "1px solid #e0e0e0", display: "flex", alignItems: "flex-end" }}>
            {tabs.map((tab) => (
                <button
                    key={tab.key}
                    onClick={() => onChange(tab.key)}
                    style={{
                        background: "none",
                        border: "none",
                        outline: "none",
                        cursor: "pointer",
                        color: activeKey === tab.key ? "#19c6c2" : "#bdbdbd",
                        fontWeight: activeKey === tab.key ? 600 : 400,
                        fontSize: 16,
                        marginRight: 24,
                        paddingBottom: 8,
                        borderBottom: activeKey === tab.key ? "3px solid #19c6c2" : "3px solid transparent",
                        transition: "color 0.2s, border-bottom 0.2s",
                    }}
                    disabled={activeKey === tab.key}
                >
                    {tab.label}
                </button>
            ))}
        </div>
    );
};

export default Tabs;